<template>
  <span :title="$t(`enum.restockPullType.${restockPullType}`)">
    <span v-if="props.restockPullType === RESTOCK_PULL_TYPE.onDemand"><font-awesome-icon :icon="['fas', 'cart-shopping']" fixed-width /></span>
    <span v-else-if="props.restockPullType === RESTOCK_PULL_TYPE.minMax">
      <font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'arrows-up-down']" fixed-width transform="" />
        <font-awesome-icon :icon="['fas', 'dash']" fixed-width transform="up-8" />
        <font-awesome-icon :icon="['fas', 'dash']" fixed-width transform="down-8" />
      </font-awesome-layers>
    </span>
    <span v-else-if="props.restockPullType === RESTOCK_PULL_TYPE.originalPack">
      <font-awesome-layers>
        <font-awesome-icon :icon="['fas', 'box']" fixed-width transform="right-4 shrink-2" />
        <font-awesome-icon :icon="['fas', 'arrows-up-down']" fixed-width transform="left-8" />
        <font-awesome-icon :icon="['fas', 'horizontal-rule']" fixed-width transform="up-8" />
        <font-awesome-icon :icon="['fas', 'horizontal-rule']" fixed-width transform="down-8" />
      </font-awesome-layers>
    </span>
    <span v-else><font-awesome-icon :icon="['fas', 'trash']" /></span>
  </span>
</template>

<script setup lang="ts">
import { RESTOCK_PULL_TYPE } from '@/models/Enums';

const props = defineProps({
  restockPullType: { type: Number, required: true },
  showText: { type: Boolean, required: false, default: true }
});
</script>
